import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RoleService } from './role.service';

@Injectable()
export class RoleGuardService  {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let result: boolean = false;

    if (Array.isArray(route.data.roles)) {
      result = this.roleService.hasRoles(route.data.roles);
    }

    /* Due to https://github.com/angular/angular/issues/18605
    * we cannot use redirectTo and canActivate on the route table
    * this code is a workaround allowing the RoleGuardService to be called with
    * additional parameters that allow navigation to take place
    * If this additional navigation is not required then don't set
    * the parameters and the guard will operate as normal
    */
    if (result && route.data.adminRoute) {
      this.router.navigate([route.data.adminRoute]);
      return of(false);
    }

    if (!result && route.data.defaultRoute) {
      this.router.navigate([route.data.defaultRoute]);
      return of(false);
    }

    return of(result);

  }

  constructor(private readonly router: Router, private readonly roleService: RoleService) {

  }
}
